import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'ThreedRotateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-3d-rotate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 3a7 7 0 0 1 7 7v4l-3 -3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M22 11l-3 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 15.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 12.5v5.5l5 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8 15.545l5 -3.03"
    }, null), _createTextVNode(" ")]);
  }
};